// extracted by mini-css-extract-plugin
export var form = "form-module--form--890f0";
export var form__container = "form-module--form__container--c31c2";
export var form__date = "form-module--form__date--f4b78";
export var form__info = "form-module--form__info--c518c";
export var form__widget = "form-module--form__widget--dd1a6";